<template>
  <div>
    <MasterLayout>
      <section class="mt-3 full__row_section">
        <div class="row_default">
          <div class="row justify-content-center align-items-center">
            <div class="col-md-3 centralise-item">
              <router-link
                :to="{
                  name: 'industrialBranchSchedule_maintenace',
                  query: {
                    branchId: $route.query.branchId
                      ? this.$route.query.branchId
                      : '',
                    companyId: $route.query.companyId,
                    groupId: $route.query.groupId,
                  },
                }"
                class="back_button vue_router_link btn btn_theme"
              >
                <img
                  src="@/assets/img/arrow - white.svg"
                  width="20px"
                  class="mr-3"
                />
                {{ $t("text.iMaintenanceHistory.back") }}
              </router-link>
            </div>
            <div class="col-md-9 centralise-item">
              <h3 class="heading-three-text">
                {{ this.$route.query.typeName }}
                {{ $t("text.iMaintenanceHistory.title") }}
              </h3>
            </div>
          </div>
        </div>
      </section>
      <section class="mt-3 full__row_section">
        <div class="row dashboard_second_row pb-4">
          <div class="col -md-4">
            <div class="row_default">
              <div
                class="dashboard__card large_card card_padding indus_back_img"
              >
                <div
                  class="row make-row-hundred-percent align-items-center justify-content-center"
                >
                  <div class="col-md-3">
                    <div
                      class="icon_wrapper yellow centralize icon_div_big"
                      style=""
                    >
                      <img src="@/assets/img/clock (1).svg" width="48" />
                    </div>
                  </div>
                  <div class="col-md-7 remove-padding-left">
                    <div class="text-center">
                      <h6 class="text-white">
                        {{ $t("text.iMaintenanceHistory.nextMaintenance") }}
                      </h6>
                    </div>
                    <div class="text-center mt-4">
                      <h5 class="text-white mt-4 font-weight">
                        {{ nextScheduleDayCount }}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3 full__row_section">
                <calendar :attributes="calendarHistory"></calendar>
              </div>
            </div>
          </div>
          <div
            class="col-md-8 dashboard_second_row_right main_history_card_container_mobile"
          >
            <div class="maint_hist_container maint_history_wrapper">
              <div class="main_hist_scroll">
                <div
                  class="dashboard__card main_history_card align-center mt-3 centralize_block"
                  v-for="(maintHist, i) in maintHistory"
                  :key="i"
                >
                  <div class="card_inner_wrapper">
                    <div class="row make-row-hundred-percent">
                      <div class="col-md-9">
                        <h4 class="date_text_header">
                          {{ maintHist.scheduleDateTime }} ({{
                            $t("text.iMaintenanceHistory.countdown")
                          }}: {{ maintHist.countdown }})
                        </h4>
                        <h6
                          class="time__stamps"
                          v-if="
                            maintHist.status ===
                            $t('text.iMaintenanceHistory.done')
                          "
                        >
                          {{ $t("text.iMaintenanceHistory.resolvedOn") }}
                          {{ maintHist.resolvedDate }}
                          {{ $t("text.iMaintenanceHistory.at") }}
                          {{ maintHist.resolvedTime }}
                        </h6>
                        <h6 class="time__stamps mt-3">
                          {{ maintHist.description }}
                        </h6>
                        <b
                          class="mt-3"
                          v-if="
                            maintHist.status ===
                            $t('text.iMaintenanceHistory.done')
                          "
                          >{{ $t("text.iMaintenanceHistory.cost") }}:
                          {{
                            industryBranch ? industryBranch.currencyCode : ""
                          }}
                          {{ convertThousand(maintHist.amount) }}
                          <!-- {{ $n(maintHist.amount, 'currency') }} -->
                        </b>
                      </div>
                      <div class="col-md-3 mt-2">
                        <button
                          :disabled="true"
                          :style="[
                            maintHist.status ===
                            $t('text.iMaintenanceHistory.pending')
                              ? { background: 'red !important', cursor: 'text' }
                              : {
                                  background: 'green !important',
                                  cursor: 'text',
                                },
                          ]"
                          class="vue_router_link btn btn_theme"
                        >
                          {{ maintHist.status }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import { VueApexCharts } from "apexcharts";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Maintenance History:: Epump Industrial Portal",
  name: "MaintenanceHistory",
  components: {
    MasterLayout,
    Highcharts: Chart,
    VueApexCharts,
    VueperSlides,
    VueperSlide,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      // linkQuery: {
      //   branchId: this.$route.query.branchId,
      //   companyId: this.$route.query.companyId,
      // },
      showLoader: false,
      industryBranch: null,
      industryBranchId: null,
      maintHistory: [],
      calendarHistory: [],
      doneDatesArr: [],
      pendingDatesArr: [],
      nextScheduleDayCount: 0,
    };
  },
  watch: {
    industryBranch: function (newIndustry, oldIndustry) {
      if (newIndustry.id !== null) {
        this.industryBranchId = newIndustry.id;
        this.getMaintenanceHistory();
      }
    },
  },
  created() {
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
      document.title = `Industry Dashboard - ${industryBranch.name}`;
    });
  },
  mounted() {},
  methods: {
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getMaintenanceHistory() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/MaintenanceHistory/${this.industryBranch.id}?typeName=${this.$route.query.typeName}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.showLoader = false;
          let countDownDays = [];
          let CountDownHours = [];
          res.data.forEach((el) => {
            if (
              el.scheduleDate === null ||
              el.scheduleDate === "null" ||
              el.scheduleDate === undefined ||
              !el.scheduleDate
            ) {
              el.scheduleDate = "N/A";
            } else {
              el.scheduleDateTime = this.$moment(el.scheduleDate).format(
                "MMMM D, YYYY h:mm A"
              );
            }
            if (
              el.amount === null ||
              el.amount === "null" ||
              el.amount === undefined ||
              !el.amount
            ) {
              el.amount = "N/A";
            } else {
            }

            if (el.resolved) {
              el.status = this.$t("text.iMaintenanceHistory.done");
              if (
                el.scheduleDate === null ||
                el.scheduleDate === "null" ||
                el.scheduleDate === undefined ||
                !el.scheduleDate
              ) {
              } else {
                el.resolvedDate = this.$moment(el.resolveDate).format(
                  "MMMM D, YYYY h:mm A"
                );
                el.resolvedTime = this.$moment(el.resolveDate).format(
                  " h:mm A"
                );
                const doneDate = new Date(el.scheduleDate);
                let day = "" + doneDate.getDate();
                let month = doneDate.getMonth() + 1;
                let year = doneDate.getFullYear();
                const doneDateStr =
                  year + "" + "," + "" + month + "" + "," + "" + day;
                this.calendarHistory.push({
                  highlight: "green",
                  dates: [new Date(doneDateStr)],
                  popover: {
                    label: el.description ? new String(el.description) : null,
                  },
                });
              }
            } else {
              el.status = this.$t("text.iMaintenanceHistory.pending");
              if (
                el.scheduleDate === null ||
                el.scheduleDate === "null" ||
                el.scheduleDate === undefined ||
                !el.scheduleDate
              ) {
              } else {
                const pendDate = new Date(el.scheduleDate);
                let day = "" + pendDate.getDate();
                let month = pendDate.getMonth() + 1;
                let year = pendDate.getFullYear();
                const dateStr =
                  year + "" + "," + "" + month + "" + "," + "" + day;
                this.calendarHistory.push({
                  highlight: "red",
                  dates: [new Date(dateStr)],
                  popover: {
                    label: el.description ? new String(el.description) : null,
                  },
                });
              }
            }
            const total =
              Date.parse(new Date(el.scheduleDate)) - Date.parse(new Date());
            const days = Math.floor(total / (1000 * 60 * 60 * 24));
            const hours = Math.floor(total / (1000 * 3600));

            if (days === 0) {
              el.countdown =
                hours + " " + this.$t("text.iMaintenanceHistory.hours");
              CountDownHours.push(hours);
              countDownDays.push(days);
            } else if (days < 0) {
              el.countdown = this.$t("text.iMaintenanceHistory.expired");
            } else if (days === 1) {
              el.countdown =
                days + " " + this.$tc("text.iMaintenanceHistory.day", 1);
            } else if (days > 0) {
              el.countdown =
                days + " " + this.$tc("text.iMaintenanceHistory.day", 2);
              countDownDays.push(days);
            }

            const minCountDown = Math.min(...countDownDays);
            if (minCountDown > 0) {
              this.nextScheduleDayCount =
                minCountDown +
                "  " +
                this.$tc("text.iMaintenanceHistory.day", 2);
            } else {
              const minCountDownHours = Math.min(...CountDownHours);
              this.nextScheduleDayCount =
                minCountDownHours +
                " " +
                this.$t("text.iMaintenanceHistory.hours");
              // this.nextScheduleDayCount = "No Schedules"
            }
          });

          this.maintHistory = res.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>
